import { DndContext } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { FormHelperText, Stack, Typography } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { filterColumnsByColumnIdsAndSectionType } from '../../constants/reportTemplateColumnList';
import { SectionType } from '../../validationSchemas/ReportTemplateSchema';
import ColumnItemSortable from './ColumnItemSortable';

interface ColumnListProps {
  name: string;
  sectionType: SectionType;
  onChange: Function;
}

function ColumnList({ name, sectionType, onChange }: ColumnListProps) {
  const form = useFormContext();
  const { getValues, watch, getFieldState } = form;

  const columnIds = watch(name);
  const { error } = getFieldState(name);
  const columnObjectList = filterColumnsByColumnIdsAndSectionType(columnIds, sectionType);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active && over && active.id !== over.id) {
      const oldIndex = columnIds.indexOf(active.id);
      const newIndex = columnIds.indexOf(over.id);
      const newColumnObjectList = arrayMove(columnObjectList, oldIndex, newIndex);
      const newColumnIds = newColumnObjectList.map((columnObject: any) => columnObject.id);
      onChange(newColumnIds);
    }
  };

  const onRemove = (columnId) => {
    const newColumnIds = columnIds.filter((id) => id !== columnId);
    onChange(newColumnIds, columnId);
  };

  const sortBy = getValues('sortBy') || [];
  const sortAscending = getValues('sortAscending') || [];

  const style1 = {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.17px',
  };

  return (
    <Stack spacing={2} px={2}>
      <Typography sx={style1}>Added Columns ({columnObjectList.length})</Typography>
      {error && <FormHelperText error>{error.message}</FormHelperText>}
      <DndContext onDragEnd={handleDragEnd}>
        <Stack spacing={2}>
          <SortableContext items={columnObjectList} strategy={verticalListSortingStrategy}>
            {columnObjectList.map((column) => (
              <ColumnItemSortable
                key={column.key}
                sort={sortBy.includes(column.id)}
                ascending={sortAscending[sortBy.indexOf(column.id)] === true}
                column={column}
                onRemove={onRemove}
              />
            ))}
          </SortableContext>
        </Stack>
      </DndContext>
    </Stack>
  );
}

export default ColumnList;
